<template>
  <div
    :class="
      $route.name == 'NewHome' || $route.name == 'WenKu'
        ? 'headshow newfix animate__animated animate__fadeInDown'
        : 'headshow'
    "
    v-show="isShow"
  >
    <div
      class="hidden-sm-and-up"
      style="
        display: flex;
        justify-content: flex-end;
        height: 50px;
        align-items: center;
        padding-right: 10px;
      "
    >
      <i @click="showMenu" class="el-icon-s-operation"></i>
    </div>
    <div
      class="hidden-xs-only header flex-row align-center"
      style="
        display: flex;
        justify-content: space-between;
        width: 1400px;
        margin: 0 auto;
      "
    >
      <img
        src="../../static/menu/logo@2x.png"
        @click="toPath('/')"
        style="width: auto; height: 50px"
      />
      <div style="display: flex">
        <!-- :style="{
          margin-left: 119px
            marginLeft: index === 0 ? '85px' : '10px',
          }" 
          :class="{
            menu: item.path === $route.path,
          }"-->
        <div
          @click="toPath(item.path)"
          v-for="(item, index) in list"
          :key="index"
          class="bg navitem"
        >
          <img
            v-if="item.pathstr.indexOf($route.path) != -1"
            :src="item.activeimg"
            alt=""
          />
          <img v-else :src="item.img" alt="" />
          <span
            class="title"
            :style="{
              color: item.pathstr.indexOf($route.path) != -1 ? '#AA1D1F' : '',
            }"
            >{{ item.title }}</span
          >
        </div>
        <!-- </div> -->

        <template v-if="!isLogin">
          <span class="right_title loginBtn" @click="toPath('/login')">
            <!-- <img
              style="width: 15px; height: 20px; margin-right: 4px"
              src="../assets/img/icon_s.png"
            /> -->
            登録
            <div
              style="
                width: 1px;
                height: 20px;
                background-color: #cacaca;
                margin-left: 10px;
              "
            ></div>
          </span>
          <span class="right_title" style="margin-left: 0.3rem">注册</span>
        </template>
        <template v-if="isLogin">
          <div style="display: flex">
            <!-- <span class="right_title loginBtn" @click="toPath('/personal')">
              <img
                style="width: 15px; height: 20px; margin-right: 4px"
                src="../assets/img/icon_s.png"
              />
              个人中心
              <div
                style="
                  width: 1px;
                  height: 20px;
                  background-color: #cacaca;
                  margin-left: 10px;
                "
              ></div>
            </span> -->
            <span
              class="right_title"
              @click="toLogin"
              style="margin-left: 0.3rem"
              >退出</span
            >
          </div>
        </template>
      </div>
    </div>
    <el-drawer :visible.sync="showDrawer" direction="rtl" size="50%">
      <div class="headerPhone flex-col align-center">
        <div
          @click="toPath(item.path)"
          v-for="(item, index) in list"
          :key="index"
          :class="{
            menu: item.path === $route.path,
          }"
          class="bg flex-col justify-center align-center"
        >
          <span
            class="title"
            :style="{
              color: item.path === $route.path ? '#AA1D1F' : '',
            }"
            >{{ item.title }}</span
          >
        </div>
        <span class="right_title" @click="toPath('/login')">登録</span>
        <span class="right_title">注册</span>
      </div>
    </el-drawer>
    <el-dialog
      width="980px"
      height="540px"
      :visible.sync="buyVisible"
      :before-close="handleCloseBuy"
    >
      <BuyConfirm :visible.sync="buyVisible"></BuyConfirm>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogFormVisible"
      width="728px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="bindbox"
    >
      <BindMobile v-if="dialogFormVisible"></BindMobile>
      <!-- :before-close="toggleDialog" -->
    </el-dialog>
  </div>
</template>

<script>
import "animate.css"
import eventBus from '@/utils/eventBus.js'
import BindMobile from '@/components/bindMobile.vue'
import {
  getInfo,
} from "@/api/api"
export default {
  name: 'App',
  components: {
    BindMobile
  },
  data () {
    return {
      isShow: true,
      isLogin: false,
      showDrawer: false,
      buyVisible: false,
      dialogFormVisible: false,
      baseUrl: window.__baseUrl__,
      list: [{
        path: '/',
        pathstr: '/',
        title: '首頁',
        img: '/static/newhome/icon/home2.png',
        activeimg: '/static/newhome/icon/home3.png'
      },
      // {
      //   path: '/show',
      //   title: '映像-書影'
      // },
      {
        path: '/wenku',
        pathstr: '/wenku',
        title: '文庫源流',
        img: '/static/newhome/icon/yuanliu2.png',
        activeimg: '/static/newhome/icon/yuanliu3.png'
      },
      {
        path: '/result',
        pathstr: '/result',
        title: '藏書匯覽',
        img: '/static/newhome/icon/cangshu2.png',
        activeimg: '/static/newhome/icon/cangshu3.png'
      },
      {
        path: '/personal',
        pathstr: '/personal,/products',
        title: '個人中心',
        img: '/static/newhome/icon/user2.png',
        activeimg: '/static/newhome/icon/user3.png'
      },
      {
        path: '/about',
        pathstr: '/about',
        title: '關於我們',
        img: '/static/newhome/icon/about2.png',
        activeimg: '/static/newhome/icon/about3.png'
      },
        // {
        //   path: '/analysis',
        //   title: '文本分析'
        // },
      ],
      isfix: false,//是否浮动
      userInfo: {}
    }
  },
  // props: {
  //   isShow: {
  //     type: Boolean,
  //     default: true
  //   }
  // },
  // computed: {
  //   isShow: {

  //     get: function () {//必须有返回值，用来获取属性，称为get函数
  //       return this.headShow
  //     },

  //   }
  // },
  mounted () {
    // window.addEventListener('scroll', this.headershow)
    this.isShow = this.$route.name != 'WenKu' ? true : false
    eventBus.$on("changeShow", (val) => {
      this.isShow = val
    })
    //购买引导弹窗
    eventBus.$on('changeBuy', (v) => {
      this.changeBuy(v)
    })
    //绑定手机号
    eventBus.$on("openBindMobile", (open) => {
      this.changeBindMObileVal(open)
    })
    eventBus.$on("getUserInfo", () => {
      this.getUserInfo()
    })
  },
  created: function () {
    this.isLogin = localStorage.getItem('token') ? true : false
    eventBus.$on('outLogin', (type) => {
      this.isLogin = localStorage.getItem('token') ? true : false
    })

  },
  methods: {
    getUserInfo () {
      getInfo().then(d => {
        localStorage.setItem('isVip', d.user && d.user.vipValidityDate)
        let userinfo = d.user
        if (userinfo) {
          userinfo.avatar = userinfo.avatar ? (userinfo.avatar.indexOf('http') == -1) ? this.baseUrl + userinfo.avatar : userinfo.avatar : '/static/logo33.png'
        }
        this.userInfo = userinfo
        // this.userinfo = userinfo
        localStorage.setItem('userInfo', JSON.stringify(userinfo))
        eventBus.$emit("outLogin", 1)
      })
    },
    changeBindMObileVal (val) {
      this.dialogFormVisible = val
    },

    changeBuy (isShow) {

      this.buyVisible = isShow
      // let ispre = this.$route.meta.prevPage
      // if (!isShow && window.history.length == 1) {  //如果是新打开页面 关闭弹窗同时关闭页面
      //   window.close()
      // }
    },
    handleCloseBuy (done) {
      // eventBus.$emit("changeBuy", false)
      this.buyVisible = false
      // this.changeBuy(false)
    },
    headershow (e) {
      this.isfix = true
      console.log(e)
    },
    toLogin () {
      localStorage.setItem('token', '')
      eventBus.$emit('outLogin', 2)
      this.$router.replace({
        path: '/login'
      })
    },
    showMenu () {
      this.showDrawer = true
    },
    toPath (path) {
      this.$router.push({
        path: path
      })
    }
  },
  beforeDestroy () {
    eventBus.$off('getUserInfo')
  }

}
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-dialog {
  border-radius: 18px;
}
.navitem {
  cursor: pointer;
  margin-right: 40px;
  text-align: center; //新增
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    height: 24px;
    width: auto;
    margin-bottom: 8px;
  }
  // p {
  //   margin: 0;
  //   padding: 0;
  // }
  // .fontstyle {
  //   margin-top: 2px;
  //   color: #fff;
  // }
}
.headshow {
  width: 100%;
  height: 2rem;
  background-color: #fff;
}
.newfix {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999999;
}
.loginBtn {
  /* margin-left: 203px; */
}

.header {
  padding-left: 0rem;
  display: flex;
  height: 2rem;
}

// .headerPhone .bg {
//   margin-top: 0.3rem;
//   margin-left: 0rem;
// }

.headerPhone .right_title {
  margin-top: 0.3rem;
}

// .bg {
//   width: 130px;
//   height: 31px;
//   cursor: pointer;
// }

.menu {
  background: url(../../static/menu/menu_bg.png) 100% no-repeat;
  background-size: 100% 100%;
}

.title {
  /* font-size: 0.4rem; */
  font-size: 12px;
}

.right_title {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.45rem;
}

@media screen and (max-width: 1400px) {
  .loginBtn {
  }
}
</style>
<style src="../pages/common.css" />



// WEBPACK FOOTER //
// src/components/header.vue